import { put } from "redux-saga/effects";

import actions from "@/actions";
import type { FloorSpaceCatalog } from "@/models/floor-space-catalog";
import * as FloorSpaceCatalogService from "@/services/floor-space-catalog";

interface LoadFloorSpaceCatalogsPayload {
    floorSpaceId: number;
}

/**
 * Fetches FloorSpaceCatalog records for a floor space and dispatches them as a lookup map.
 *
 * @param {LoadFloorSpaceCatalogsPayload} payload - The payload containing the floor space ID.
 * @yields Calls the FloorSpaceCatalog service and dispatches setFloorSpaceCatalogMap.
 */
function* loadFloorSpaceCatalogs({
    floorSpaceId,
}: LoadFloorSpaceCatalogsPayload) {
    const catalogs: FloorSpaceCatalog[] =
        yield FloorSpaceCatalogService.getByFloorSpaceId(floorSpaceId);

    const catalogMap: Record<number, FloorSpaceCatalog> = {};

    for (const catalog of catalogs) {
        catalogMap[catalog.floorSpaceCatalogID] = catalog;
    }

    yield put(actions.map.general.setFloorSpaceCatalogMap(catalogMap));
}

export default loadFloorSpaceCatalogs;
